import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { AuthenticationService, ContextService } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthenticationService, private context: ContextService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.token;

    if (request.url.startsWith(this.context.serviceUrl)) {
      return next.handle(request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`),
      }));
    } else {
      return next.handle(request);
    }
  }
}
